import { supabase } from "@/integrations/supabase/client";

export type TaskMediaRecommendation = {
  taskText: string;
  room: string;
  mediaType: "photo" | "video";
  rationale: string;
  videoSteps?: string[];
};

export async function getChecklistMediaRecommendations(
  propertyId: string,
  tasks: { taskText: string; room: string }[]
): Promise<TaskMediaRecommendation[]> {
  if (tasks.length === 0) return [];

  const { data, error } = await supabase.functions.invoke("recommend-checklist-media", {
    body: { propertyId, tasks },
  });

  if (error) throw new Error(error.message ?? "Recommendation failed");

  const result = data as { recommendations?: TaskMediaRecommendation[]; error?: string };
  if (result?.error) throw new Error(result.error);
  return Array.isArray(result?.recommendations) ? result.recommendations : [];
}
